/**
 * Renders a page for a section of the Utah Code.
 * @param {React.ReactNode} children - The content to render inside the page.
 * @returns {JSX.Element}
 */
export default function SectionPage({ children }) {
  return (
    <article className="m-auto w-full py-8 sm:w-9/12">
      <div>{children}</div>
    </article>
  );
}
